import { render, staticRenderFns } from "./directors.vue?vue&type=template&id=14895b1c&scoped=true"
import script from "./directors.vue?vue&type=script&lang=js"
export * from "./directors.vue?vue&type=script&lang=js"
import style0 from "./directors.vue?vue&type=style&index=0&id=14895b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14895b1c",
  null
  
)

export default component.exports